<template>
    <div class="container">
        <canvas ref="canvas" width="900" height="400"></canvas>
    </div>
</template>
<script>

    //import VueCharts from 'vue-chartjs'
    import { Line } from 'vue-chartjs'

    export default {
        name: 'Widget',
        extends: Line,
        props: ['dataset','labels','options'],
        data () {
            return {
                colors: [
                    'rgba(247, 0, 65, #)',
                    'rgba(187, 1, 240, #)',
                    'rgba(1, 170, 240, #)',
                    'rgba(1, 240, 170, #)',
                    'rgba(247, 0, 65, #)',
                    'rgba(187, 1, 240, #)',
                    'rgba(1, 170, 240, #)',
                    'rgba(1, 240, 170, #)'
                ]
            }
        },
        mounted: function(){

            var datasets = [];
            let colorIndex = 0
            for(var index in this.dataset) {
                let element = this.dataset[index];

                // Overwriting base render method with actual data.
                let gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 400, 0, 100)
                    gradient.addColorStop(0, this.colors[colorIndex].replace('#', 0.2))
                    gradient.addColorStop(1, this.colors[colorIndex].replace('#', 0.4))

                console.log("name", element.name)
                console.log("data", element.data)
                datasets.push({
                    label: element.name,
                    backgroundColor: gradient,
                    data: element.data,
                    borderColor: this.colors[colorIndex].replace('#', 1),
                    pointBorderColor: '#ffffff',
                    pointBackgroundColor: this.colors[colorIndex].replace('#', 1),
                    pointHoverBorderColor: this.colors[colorIndex].replace('#', 1),
                    pointBorderWidth: 2,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 2,
                    pointRadius: 4,
                    borderWidth: 2,
                });

                colorIndex ++

            };


            this.renderChart({
                labels: this.labels,
                responsive: true,
                maintainAspectRatio: true,
                datasets: datasets
            }, this.options)

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/chart/Spline.vue